<template lang="html">
  <v-layout column>
    <v-card>
      <v-master-detail-pane>
        <template slot="master">
          <v-load-nav-list title="Bills"
                           searchPrompt="Search Billed Transactions"
                           :loading="loadingTransactions"
                           :accurateSince="accurateSince"
                           :loads="bills"
                           :groupedItems="billsGroupedByStatus"
                           :carrierLoads="billsGroupedByCarrier"
                           :company="company"
                           @update:searchTerm="search = $event"
                           @refresh="loadCompanyTransactions(company.id)">

            <template slot="loadTile"
                      slot-scope="{ idx, load: txn }">

              <v-list-tile :key="`load_txn_${idx}_${txn.id}`"
                           @click="selectLoad(txn)"
                           :class="{'primary lighten-1': isSelectedLoad(txn)}"
                           :inactive="isSelectedLoad(txn)"
                           ripple avatar>

                <v-list-tile-content>
                  <v-list-tile-title>{{ txn.vendor.companyName }}</v-list-tile-title>
                  <v-list-tile-sub-title class="text--primary" v-if="bookedLoadNickname(txn.load)">
                    {{ bookedLoadNickname(txn.load) }}
                  </v-list-tile-sub-title>
                  <v-list-tile-sub-title class="text--primary">
                          <span v-if="txn.load.pickup">
                            {{ txn.load.pickup.when | formatTxDate}}
                          </span>
                    <span v-else-if="txn.load.tacticalInfo.scheduledPickupTime">
                            {{ txn.load.tacticalInfo.scheduledPickupTime | formatTxDate}}
                          </span>
                  </v-list-tile-sub-title>
                  <v-list-tile-sub-title>
                    {{ txn.loadHumanId }}: ${{ txn.amount }} ({{ txn.status || '[status]' }})
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-chip :color="billStatusIcon(txn).color"
                          text-color="white" small>
                    <v-icon>
                      {{ billStatusIcon(txn).icon }}
                    </v-icon>
                  </v-chip>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider :key="`load_txn_divider_${idx}_${txn.id}`"/>

            </template>

            <template slot="groupedItemsTile" slot-scope="skope">
              <v-list-group :key="`billGroupedBy_${skope.idx}`">
                <v-list-tile slot="activator">
                  <v-list-tile-action>
                    <v-list-tile-action>
                      <v-chip :color="billStatusIcon({load: {loadStatus: skope.item} }).color"
                              text-color="white" small>
                        <v-icon>
                          {{ billStatusIcon({load: {loadStatus: skope.item } }).icon }}
                        </v-icon>
                      </v-chip>
                    </v-list-tile-action>
                  </v-list-tile-action>
                  <v-list-tile-title>
                    {{skope.item}}
                  </v-list-tile-title>
                </v-list-tile>
                <template v-for="txn in skope.items" >
                  <v-list-tile :key="`grouped_load_${txn.loadId}`"
                               @click="selectLoad(txn)"
                               :class="{'primary lighten-1': isSelectedLoad(txn)}"
                               :inactive="isSelectedLoad(txn)"
                               ripple avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{ loadGroupSponsorName(txn.load.tacticalInfo.loadGroup) }}
                      </v-list-tile-title>
                      <v-list-tile-sub-title class="text--primary"
                                             v-if="bookedLoadNickname(txn.load)">
                        {{ bookedLoadNickname(txn.load) }}
                      </v-list-tile-sub-title>
                      <v-list-tile-sub-title class="text--primary">
                              <span v-if="txn.load.pickup">
                                {{ txn.load.pickup.when | formatTxDate}}
                              </span>
                        <span v-else-if="txn.load.tacticalInfo.scheduledPickupTime">
                                {{ txn.load.tacticalInfo.scheduledPickupTime }}
                              </span>
                      </v-list-tile-sub-title>
                      <v-list-tile-sub-title>
                        {{ txn.loadHumanId }}: ${{ txn.amount }}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider :key="`load_divider_${txn.loadId}`"/>
                </template>
              </v-list-group>
            </template>

            <template slot="carrierLoadsTile" slot-scope="skope">
              <v-list-group :key="`carrierLoad_${skope.idx}`">
                <v-list-tile slot="activator">
                  <v-list-tile-action>
                    <v-chip color="primary"
                            text-color="white" small>
                      {{ skope.loads.length }}
                    </v-chip>
                  </v-list-tile-action>
                  <v-list-tile-title>
                    {{skope.carrier}}
                  </v-list-tile-title>
                </v-list-tile>
                <template v-for="txn in skope.loads" >
                  <v-list-tile :key="`grouped_load_${txn.loadId}`"
                               @click="selectLoad(txn)"
                               :class="{'primary lighten-1': isSelectedLoad(txn)}"
                               :inactive="isSelectedLoad(txn)"
                               ripple avatar>
                    <v-list-tile-content>
                      <v-list-tile-title class="text--primary"
                                         v-if="bookedLoadNickname(txn.load)">
                        {{ bookedLoadNickname(txn.load) }}
                      </v-list-tile-title>
                      <v-list-tile-sub-title>
                        {{ _.get(txn, 'load.loadStatus', '') }}
                      </v-list-tile-sub-title>
                      <v-list-tile-sub-title class="text--primary">
                              <span v-if="txn.load.pickup">
                                {{ txn.load.pickup.when | formatTxDate}}
                              </span>
                        <span v-else-if="txn.load.tacticalInfo.scheduledPickupTime">
                              {{ txn.load.tacticalInfo.scheduledPickupTime | formatTxDate}}
                              </span>
                      </v-list-tile-sub-title>
                      <v-list-tile-sub-title>
                        {{ txn.loadHumanId }}: ${{ txn.amount }}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider :key="`load_divider_${txn.loadId}`"/>
                </template>
              </v-list-group>
            </template>
          </v-load-nav-list>
        </template>

        <template slot="detail">
          <v-load-transaction-details v-if="selected"
                                      :transaction="selected"
                                      bill
                                      :company="company"
                                      @reload="onRefresh()"
                                      @reset-selected="selectLoad(null)"
                                      :banner-title="`${selected.loadHumanId}`"
                                      :loading="loadingTransactions">
            <template slot="toolbarButtons">
              <!-- nothing to go here really -->
            </template>
          </v-load-transaction-details>
        </template>
      </v-master-detail-pane>
    </v-card>
  </v-layout>
</template>

<script>
import _ from 'lodash';
import * as Timestamps from '@/types/timestamp';

import bookedLoadMixin from '@/mixins/bookedLoadMixin';
import filterLoadsMixin from '@/mixins/filterLoads';
import loadGroupMixin from '@/mixins/loadGroupMixin';
import loadTransactionsMixin from '@/mixins/loadTransactionsMixin';

import VMasterDetailPane from '@/components/MasterDetailPane';
import VLoadNavList from '@/components/dashboard/simple/LoadNavList';
import VLoadTransactionDetails from '@/components/dashboard/simple/LoadTransactionDetails';

export default {
  name: 'Bills',
  mixins: [
    bookedLoadMixin,
    filterLoadsMixin,
    loadGroupMixin,
    loadTransactionsMixin,
  ],
  components: {
    VLoadNavList,
    VLoadTransactionDetails,
    VMasterDetailPane,
  },
  props: {
    txId: {
      type: String,
      required: false,
    },
    company: {
      type: Object,
    },
  },
  watch: {
    selected() {
      if (_.get(this.selected, 'id', false)) {
        this.$router.push({ params: { txId: this.selected.id } });
      }
    },
    loadingTransactions() {
      if (this.$route.params.txId) {
        this.selected = _.find(this.billTransactions, { id: this.$route.params.txId });
      }
    },
  },
  filters: {
    formatTxDate(dateString) {
      return dateString ? Timestamps.formattedDate(dateString) : '';
    },
  },
  computed: {
    _() {
      return _;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    bills() {
      return _.filter(this.billTransactions, tx => this.filterLoadTransaction(tx));
    },
    payableCount() {
      return _.get(this.bills, 'length', '');
    },
    billsGroupedByStatus() {
      const nameSorted = _.sortBy(this.bills, tx => _.get(tx, 'customer.companyName', ''));
      return _.groupBy(nameSorted, tx => _.get(tx, 'load.loadStatus', ''));
    },
    billsGroupedByCarrier() {
      const nameSorted = _.sortBy(this.bills, tx => _.get(this.transactionHaulingCompany(tx), 'name', ''));
      return _.groupBy(nameSorted, tx => _.get(this.transactionHaulingCompany(tx), 'name', ''));
    },
    accurateSince() {
      if (this.loadingTransactions) {
        return 'Loading ...';
      }

      if (this.transactionsTime) {
        return `Updated ${this.$options.filters.formatTimeStamp(this.transactionsTime)}`;
      }

      return 'Refresh';
    },

    hasTransactionsPermissions() {
      // pass through to the mixin probably
      return true;
    },
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.txId !== from.params.txId && to.params.txId !== _.get(this.selected, 'id', null)) {
      this.selected = _.find(this.billTransactions, { id: to.params.txId });
    }

    next();
  },
  methods: {
    selectLoad(txn) {
      if (this.isMobile && txn) {
        this.$router.push({ name: 'transaction.detail',
          params: { id: txn.id } });
      } else {
        this.selected = txn;
      }
    },
    isSelectedLoad(txn) {
      return txn.id === _.get(this.selected, 'id', null);
    },
    bookedLoadIcon(txn) {
      return this.bookedLoadProgressIcon(txn.load);
    },
    billStatusIcon(txn) {
      // let's help identify the actionable transactions
      return this.bookedLoadIcon(txn);
    },
  },
  data: () => ({
    selected: null,
  }),
  beforeDestroy() {
    const storageKey = `${this.company.id}_tr_bill`;
    if (_.get(this.selected, 'id', false)) {
      localStorage.setItem(storageKey, this.selected.id);
    } else {
      localStorage.removeItem(storageKey);
    }
  },
  created() {
    const storageItem = localStorage.getItem(`${this.company.id}_tr_bill`);
    if (storageItem) {
      this.selected = _.find(this.billTransactions, { id: storageItem });
    }
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Companies/Transactions/Bills.vue